import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment } from "vue"

import { useIntersectionObserver } from '@vueuse/core'

import { ref } from 'vue'

import AdBlock from '@/components_new/AdBlock.vue'
import Button from '@/components_new/Button.vue'
import { useLoggerStore } from '@/store/logger'
import { useIsMounted } from '@/utils/vue-hooks/use-is-mounted'


export default /*@__PURE__*/_defineComponent({
  __name: 'DesktopStickyBanner',
  setup(__props) {

const loggerStore = useLoggerStore()
const isMounted = useIsMounted()

const isBannerVisible = ref(true)
const isStickyMode = ref(true)

const sentinelRef = ref<HTMLDivElement>()

function onClose() {
    loggerStore.logEvent({
        event: 'custom_event',
        eventName: 'ad_close',
        adPlacement: 'sticky_desktop',
    })
    isBannerVisible.value = false
}

useIntersectionObserver(sentinelRef, (entries) => {
    isStickyMode.value = !entries[0].isIntersecting
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "sentinelRef",
      ref: sentinelRef
    }, null, 512),
    (_unref(isMounted))
      ? (_openBlock(), _createBlock(_Transition, {
          key: 0,
          enterFromClass: _ctx.$style.fade_enter_from,
          enterActiveClass: _ctx.$style.fade_enter_active,
          leaveActiveClass: _ctx.$style.fade_leave_active,
          leaveToClass: _ctx.$style.fade_leave_to,
          appear: ""
        }, {
          default: _withCtx(() => [
            (isBannerVisible.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_ctx.$style.banner)
                }, [
                  _createVNode(AdBlock, { type: "sticky_desktop" }, {
                    default: _withCtx(({ isVisible }) => [
                      (isVisible && isStickyMode.value)
                        ? (_openBlock(), _createBlock(Button, {
                            key: 0,
                            size: "s",
                            color: "carbon-400",
                            class: _normalizeClass(_ctx.$style.close_button),
                            interfaceTarget: "close-sticky-desktop-banner",
                            onClick: onClose
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$tr('desktopStickyBanner.closeButtonLabel')), 1)
                            ]),
                            _: 1
                          }, 8, ["class"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["enterFromClass", "enterActiveClass", "leaveActiveClass", "leaveToClass"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})